import { WorkspaceEntityType } from "./store/types";
import { DatapointIdStandardEnum } from "api/ux/src";
export const fundFilters = [
    DatapointIdStandardEnum.FundFundId,
    DatapointIdStandardEnum.FundInvestorId,
    DatapointIdStandardEnum.FundStrategy,
    DatapointIdStandardEnum.FundVintageYear,
    DatapointIdStandardEnum.FundGeography,
    DatapointIdStandardEnum.FundCurrency,
    DatapointIdStandardEnum.FundAssetClass,
    DatapointIdStandardEnum.FundLastClosingDate,
    DatapointIdStandardEnum.FundInceptionDate,
    DatapointIdStandardEnum.FundEndDate
];
export const assetFilters = [
    DatapointIdStandardEnum.AssetAssetId,
    DatapointIdStandardEnum.AssetType,
    DatapointIdStandardEnum.AssetAssetCurrency,
    DatapointIdStandardEnum.AssetSector,
    DatapointIdStandardEnum.AssetSubIndustry,
    DatapointIdStandardEnum.AssetMSCISector,
    DatapointIdStandardEnum.AssetApacsSector,
    DatapointIdStandardEnum.AssetCountry,
    DatapointIdStandardEnum.AssetCity,
    DatapointIdStandardEnum.AssetMsaOrMetropolitanArea,
    DatapointIdStandardEnum.AssetNcreifRegion,
    DatapointIdStandardEnum.AssetInitialStrategy,
    DatapointIdStandardEnum.AssetYearBuilt,
    DatapointIdStandardEnum.AssetInvestmentYear,
    DatapointIdStandardEnum.AssetInvestmentStatus,
    DatapointIdStandardEnum.AssetControlInDeal,
    DatapointIdStandardEnum.AssetDealSource,
    DatapointIdStandardEnum.AssetDealStyle,
    DatapointIdStandardEnum.AssetDealCoInvestors,
    DatapointIdStandardEnum.AssetState,
    DatapointIdStandardEnum.AssetExitMethods,
    DatapointIdStandardEnum.AssetExitStyle,
    DatapointIdStandardEnum.AssetInitialDealType,
    DatapointIdStandardEnum.AssetTransactionLeads,
    DatapointIdStandardEnum.AssetInitialInvestmentDate,
    DatapointIdStandardEnum.AssetLastRealizationDate,
    DatapointIdStandardEnum.AssetLastValuationDate
];
export const marketFilters = [
    DatapointIdStandardEnum.FundStrategy,
    DatapointIdStandardEnum.FundVintageYear,
    DatapointIdStandardEnum.FundGeography
];
export const managerFilters = [DatapointIdStandardEnum.ManagerManagerId];
export const dashboardTypeToFilters = new Map([
    [WorkspaceEntityType.PORTFOLIO, [...fundFilters, ...assetFilters, ...managerFilters]],
    [WorkspaceEntityType.MANAGER, [...fundFilters.filter((f) => !f.includes(DatapointIdStandardEnum.FundInvestorId)), ...assetFilters]],
    [WorkspaceEntityType.FUND, assetFilters],
    [WorkspaceEntityType.MARKET, marketFilters]
]);
